<template>
  <div class="right-side-module">
    <div class="iconfont icon-QQ" @click="openToQQChat()"></div>
    <div class="scroll-to-top-btn" @click="handleScrollToTop">
      <div class="iconfont icon-sanjiao2"></div>
      <div class="top-text">top</div>
    </div>
  </div>
</template>

<script>
import { useRoute, useRouter } from "vue-router";
import { inject } from "@vue/runtime-core";
import { openToQQChat } from "@/utils/other.js";

export default {
  name: "fixedRightSideModule",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const isMobile = inject("isMobile");
    function handleScrollToTop() {
      if (route.name === "home" && !isMobile) {
        router.replace({
          name: route.name,
          query: {
            ...route.query,
            swiperIndex: 0,
          },
        });
      } else {
        window.scrollTo(0, 0);
      }
    }
    return {
      handleScrollToTop,
      openToQQChat
    };
  },
};
</script>

<style lang='scss' scoped>
.right-side-module {
  position: fixed;
  z-index: 100;
  right: 0;
  top: 50%;
  transform: translate3d(0, -50%, 0);

  .icon-QQ {
    width: 50px;
    height: 50px;
    line-height: 50px;
    background: #03a10e;
    text-align: center;
    font-size: 32px;
    color: #fff;
    cursor: pointer;
  }

  .scroll-to-top-btn {
    width: 50px;
    height: 35px;
    background: #f8f8f8;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    .icon-sanjiao2 {
      margin-top: -4px;
      font-size: 10px;
      color: #bfbfbf;
    }
    .top-text {
      margin-top: -8px;
      line-height: 1;
      font-weight: 500;
      font-size: 16px;
      color: #606060;
    }
  }
}
</style>
